const baseFitmentFields = ['MakeModel', 'Year'];
const extraFitmentFields = ['Engine', 'Transmission'];

const categorySelectionPageUrl = '/produktkategorien/';
const brandSelectionPageUrl = '/brands/';
const genericVehiclePageUrl = '/vehicle/';

const isVehicleLandingCategory = window.location.pathname.startsWith(genericVehiclePageUrl);
const isVehicleLandingPage = !!window.document.querySelector('#cm-vehicle-landing-page');
const isOnSalePage = window.location.pathname.startsWith('/sales');

window.Convermax.showFitmentTable = () =>
  window.document.querySelector('a[href="#tab-fitment-details"]').click();

window.Convermax.handleWishlistDropdown = (e) => {
  const wishlistDropdownForm = e.currentTarget.parentElement;
  const wishlistDropdown = e.currentTarget.parentElement.querySelector('.dropdown-menu');

  if (wishlistDropdownForm) {
    wishlistDropdownForm.classList.toggle('is-open');
  }

  if (wishlistDropdown) {
    wishlistDropdown.classList.toggle('is-open');

    // handle click on document, close opened dropdown
    if (wishlistDropdown.classList.contains('is-open')) {
      const handleClickOnDocument = (event) => {
        if (!wishlistDropdownForm.contains(event.target)) {
          wishlistDropdownForm.classList.remove('is-open');
          wishlistDropdown.classList.remove('is-open');
          document.removeEventListener('click', handleClickOnDocument);

          if (window.innerWidth <= 1000) {
            document.removeEventListener('touchmove', handleClickOnDocument);
          }
        }
      };

      document.addEventListener('click', handleClickOnDocument);

      if (window.innerWidth <= 1000) {
        document.addEventListener('touchmove', handleClickOnDocument);
      }
    }
  }
};

window.Convermax.handleProductCompareClick = () => {
  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );

  const compareButton = window.document.body.querySelector('.cm_card-compare');

  if (!compareButton) {
    return;
  }

  const compareLink = window.document.body.querySelector('.cm_card-compare_link');
  const compareCount = window.document.body.querySelector('.cm_card-compare_count');

  compareCount.textContent = productsIdsToCompare.length;
  compareButton.classList.toggle('show', productsIdsToCompare.length > 1);
  compareLink.href = `/compare/${productsIdsToCompare.join('/')}/`;
};

window.Convermax.handleCompareResetClick = () => {
  const productCheckboxes = window.document.querySelectorAll('input[name="products[]"]:checked');
  productCheckboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });
  window.Convermax.handleProductCompareClick();
};

const getLang = () => 'de';

Convermax.getLang = getLang;

function updateCallback() {
  window.document.body.classList.add(`cm_${getLang()}`);

  const pagination = window.document.querySelector('.cm_SearchHeader .cm_pagination');

  // handle case, when SearchHeader doesn't contain pagination
  window.document
    .querySelector('.cm_SearchHeader .cm_sort')
    ?.classList.toggle('without-pagination', !pagination);
}

function getLocalPreselection(pageType, defaults) {
  if (isOnSalePage) {
    return [{ field: 'on_sale', term: 'True' }];
  }

  if (isVehicleLandingPage) {
    return [{ field: 'Vehicle', term: window.location.pathname }];
  }

  return defaults.getter(pageType);
}

function isGrossRetailGroup() {
  const groupName = getCustomerGroupName();
  return groupName.includes('forum') || groupName.includes('friendly') || groupName.includes('community');
}

function getCustomerGroupId() {
  return window.Convermax.BigCommerce?.getCustomerGroupId() || '1'; // Retail
}

function getCustomerGroupName() {
  return (
    window.jsContext?.customer?.customer_group_name ||
    window.document.querySelector('body')?.getAttribute('data-customer-group') ||
    ''
  ).toLowerCase();
}

function getCountry() {
  const rawCountry = window.Convermax.country;
  if (!rawCountry) {
    return null;
  }

  return mapCountryNameToCode(rawCountry);
}

function mapCountryNameToCode(countryStr) {
  switch (countryStr) {
    case 'Germany':
    case 'Deutschland':
    case 'Niemcy':
      return 'DE';
    case 'Poland':
    case 'Polen':
    case 'Polska':
      return 'PL';
    case 'Switzerland':
    case 'Schweiz':
    case 'Suisse':
    case 'Svizzera':
      return 'CH';
    case 'Norway':
    case 'Norwegen':
      return 'NO';
    default:
      // Theme mapCountryNameToCode: unknown names use DE. ISO codes (checkout) stay as-is.
      return countryStr?.length === 2 ? countryStr.toUpperCase() : 'DE';
  }
}

function getTaxExtras() {
  return {
    country: getCountry(),
    rawTaxCountry: window.Convermax.country,
    customerGroupId: getCustomerGroupId(),
    customerGroupName: getCustomerGroupName(),
    isLoggedIn: window.Convermax.BigCommerce?.isLoggedIn === true,
    lang: getLang(),
    isGrossRetailGroup: isGrossRetailGroup(),
    defaultTaxZone: 'DE',
    enableForumGrossMsrp: true,
  };
}

// Client Request: Clicking "Alle Produkte" in the nav bar should also redirect to the same vehicle landing page.
// If the selected vehicle has no landing page or the vehicle is discarded, restore the original link
function responseHandler(response) {
  const { vehicleLandingUrl } = response.Extra;
  const navBarAllProducts = window.document.querySelectorAll('a.navPages-action[aria-label="Alle Produkte"]');

  if (navBarAllProducts.length > 0) {
    navBarAllProducts.forEach((navItem) => {
      if (!navItem.dataset.originalHref) {
        navItem.dataset.originalHref = navItem.getAttribute('href') || navItem.href;
      }

      navItem.href = vehicleLandingUrl
        ? window.Convermax.getVehicleUrl(vehicleLandingUrl)
        : navItem.dataset.originalHref;
    });
  }

  return response;
}

export default {
  platform: 'bigcommerce',
  responseHandler,
  sortFields: [
    'relevance',
    ...(getLang() === 'en' ? ['name_en', 'name_en:desc'] : ['name', 'name:desc']),
    'price',
    'price:desc',
  ],
  pagination: {
    edgeRange: 2,
    centralRange: 1,
  },
  SearchRequestDefaults: {
    pageSize: 24,
    extra: {
      isOnSalePage,
      ...getTaxExtras(),
    },
    sort: window.document.querySelector('#cm_results.cm_new-products')
      ? 'pdm_created_date:desc'
      : 'relevance',
  },
  getSearchRequestDefaults: (pageType) => {
    return {
      extra: {
        pageType,
        ...getTaxExtras(),
      },
    };
  },
  autocomplete: {
    requestDefaults: {
      extra: {
        ...getTaxExtras(),
      },
    },
  },
  getLocalPreselection,
  product: {
    priceFormatter: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }),
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: genericVehiclePageUrl, field: 'category' },
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'brand_name' },
      {
        pathname:
          // https://velocity-group.de/ram/1500/ but not https://velocity-group.de/vehicle/classic-ford-mustang
          isVehicleLandingPage && !window.document.querySelector('.recommended-products')
            ? window.location.pathname
            : null,
        field: 'category',
      },
    ],
    categorySelectionPageRedirect: true,
    isAutoRedirectDisabled: true,
    hideVehicleFromUrl: isVehicleLandingCategory || isVehicleLandingPage,
    isAutoVehicleSelectionDisabled: true,
  },
  page: {
    getPageType: (defaults) =>
      window.document.querySelector('body.page_type__default')
        ? 'home'
        : window.document.querySelector('body.page_title__search')
          ? 'search'
          : window.location.pathname === genericVehiclePageUrl
            ? 'generic-vehicle'
            : window.document.querySelector('body.page_type__brands') ||
                window.location.pathname === categorySelectionPageUrl
              ? 'parts'
              : window.document.querySelector('body.page_type__category')
                ? 'category'
                : defaults.getter(),
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: 'body.page_type__category .page',
      template: 'SearchPage',
      visibleIf: () =>
        !window.document.querySelector('.page.vehicle-page') &&
        window.location.pathname !== categorySelectionPageUrl,
    },
    {
      name: 'BrandPage',
      type: 'SearchPage',
      location: 'body.page_type__brand .page-content',
      template: 'SearchPage',
    },

    {
      name: 'HeaderVehicleWidget_landingPage',
      type: 'VehicleWidget',
      location: {
        insertBefore: '.page.vehicle-page .top-categories, .page_type__page .top-categories',
      },
      template: 'fitmentSearch/searchVehicleWidgetContainer',
      fields: baseFitmentFields,
      columnBreakpoint: 700,
    },
    {
      name: 'GenericVehicleSearchPage',
      type: 'SearchPage',
      location: {
        lastChildOf: '.page.vehicle-page .recommended-products, .page_type__page .recommended-products',
        class: 'cm_generic-vehicle-search-result',
      },
      template: 'MainContent',
    },
    {
      name: 'GenericVehicleCategories',
      type: 'FacetTiles',
      location: `.page.vehicle-page div[data-content-region="vehicle_page_top_categories"],
          .page_type__page div[data-content-region="vehicle_page_top_categories"],
          .page_type__page div[data-content-region="„vehicle_page_top_categories”"],
          .page_type__404 div[data-content-region="vehicle_page_top_categories"]`,
      template: 'facetTiles/landingSubtitles',
      facetField: 'category',
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select',
    },
    {
      name: 'FacetPanel',
    },
    {
      name: 'CategoryFacet',
      type: 'FacetPanel',
      fields: 'category',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      initCollapsed: true,
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields: ['category', 'Vehicle'],
    },
    {
      name: 'VehicleSpecs',
      type: 'VehicleWidget',
      isAlwaysColumnLayout: true,
      fields: extraFitmentFields,
    },
    {
      name: 'SearchResult',
      updateCallback,
    },
    {
      name: 'SearchBox',
      location: '.header-navigation__search',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxMobile',
      type: 'SearchBoxDialogButton',
      location: '.navPages-quickSearch .container',
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '.navPages-list .navPages-item:nth-child(2)',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      initCollapsed: true,
      isAlwaysColumnLayout: true,
      fields: baseFitmentFields,
    },
    {
      name: 'HomeVehicleWidget__desktop',
      type: 'VehicleWidget',
      location: '.car-selection',
      template: 'fitmentSearch/homeVehicleWidget',
      fields: baseFitmentFields,
      columnBreakpoint: 400,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      fields: baseFitmentFields,
      columnBreakpoint: 700,
    },
    {
      name: 'Garage',
      location: '.header-navigation__garage',
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment__desktop',
      type: 'VerifyFitment',
      location: { firstChildOf: '.desktop-only #tab-description' },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'VerifyFitment__mobile',
      type: 'VerifyFitment',
      location: { firstChildOf: '.mobile-only #tab-description' },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTableDesktop',
      type: 'FitmentTable',
      location: '.desktop-only #tab-fitment-details',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableMobile',
      type: 'FitmentTable',
      location: '.mobile-only #tab-fitment-details',
      template: 'fitmentSearch/fitmentTable',
      columnBreakpoint: 700,
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: 'body.page_type__category .page',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.location.pathname === categorySelectionPageUrl,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: { replace: 'body.page_type__brands .brandGrid' },
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
      fields: baseFitmentFields,
    },
  ],
};
